import { FormModal, Modal } from "@bluframe/blublocks"
import Button from "components/buttons/Button"
import InputText from "components/inputs/Text"

import { ComponentProps } from "."
import Check from "./Check"
import { Buttons, Left, Name, Wrapper } from "./styled"

const PodSource = ({
  areItemsLoading,
  isCompact,
  isCreated,
  isEditOpen,
  isLoading,
  isValid,
  itemLabel,
  label,
  modalContent,
  onCancel,
  onClear,
  onSave,
  onSetIsEditOpen,
  serviceName,
  text
}: ComponentProps) => (
  <Wrapper $isCompact={isCompact}>
    <Left $isCompact={isCompact}>
      {isCompact ? (
        <Name>{label}</Name>
      ) : (
        <InputText
          disabled
          id={serviceName}
          label={label}
          name={serviceName}
          text={text}
        />
      )}

      <Check
        disabled={areItemsLoading || !text}
        isGreen={isValid}
        isLoading={isLoading}
        label={isCompact ? undefined : "Preview Valid"}
      />

      <Check
        disabled={areItemsLoading || !text}
        isGreen={isCreated}
        isLoading={isLoading}
        label={isCompact ? undefined : `${itemLabel} Created`}
      />
    </Left>

    {isCompact ? null : (
      <Buttons>
        <Button
          disabled={areItemsLoading || isLoading || !text}
          label="Edit"
          onClick={onSetIsEditOpen(true)}
          outlined
        />

        <Button
          disabled={areItemsLoading || isLoading || !text}
          label="Clear"
          onClick={onClear}
          outlined
          secondary
        />
      </Buttons>
    )}

    <Modal isOpen={isEditOpen} name="Critics Review" onClose={onCancel}>
      <FormModal onClose={onCancel} onSubmit={onSave}>
        {modalContent}
      </FormModal>
    </Modal>
  </Wrapper>
)
export default PodSource
